import { useQuery } from "@tanstack/react-query";
import { isUiMockMode } from "@/config/features";
import { MOCK_TRIAL_DAYS_LEFT } from "@/config/trial";
import { fetchBillingStatus } from "@/features/billing/api/billing";
import type { BillingStatus } from "@/types/api";

export const BILLING_STATUS_QUERY_KEY = ["billing", "status"] as const;

export function useBillingStatus() {
  const mock = isUiMockMode();
  const query = useQuery({
    queryKey: BILLING_STATUS_QUERY_KEY,
    queryFn: () => fetchBillingStatus(),
    enabled: !mock,
    staleTime: 30_000,
  });

  const mockStatus: BillingStatus = {
    vip_level: "trial",
    trial_ends_at: new Date().toISOString(),
    trial_days_left: MOCK_TRIAL_DAYS_LEFT,
    trial_active: true,
    subscribed: false,
    can_manage_billing: false,
    cancel_at_period_end: false,
    can_export: true,
    exports_used_this_month: 0,
    max_exports_per_month: -1,
    max_items_per_job: 2000,
    can_inline_pdf: true,
    can_paginate: true,
    can_selection_export: true,
    can_bulk_export: true,
    can_pay_links_csv: true,
    can_redownload_history: true,
  };

  return {
    mock,
    ...query,
    status: mock ? mockStatus : query.data,
  };
}
